import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from } from 'rxjs';
import { concatMap, toArray } from 'rxjs/operators';

import { VirtualChannelMoveRequest } from '../models/requests/virtual-channel-move.request';

@Injectable({
  providedIn: 'root',
})
export class VirtualChannelService {
  constructor(private http: HttpClient) {}

  move({ accommodation_channel_ids, ...payload }: VirtualChannelMoveRequest) {
    return from(accommodation_channel_ids).pipe(
      concatMap((accommodation_channel_id) =>
        this.http.put('channelmanager/virtual_channel', {
          ...payload,
          accommodation_channel_id,
        }),
      ),
      toArray(),
    );
  }
}
